import React, {Component} from 'react';
import { DragSource, DropTarget } from 'react-dnd';
import flow from 'lodash/flow'
import { findDOMNode } from 'react-dom';
import Fontawesome from 'react-fontawesome'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
const style = {
   
};

const cardSource = {
    isDragging(props, monitor) {
        return monitor.getItem().id === props.id
    },

    beginDrag(props) {
        return {
            id: props.id,
            index: props.index,
        }
    },
};
  
const cardTarget = {
    hover(props, monitor, component) {
        const dragIndex = monitor.getItem().index
        const hoverIndex = props.index
  
        if (dragIndex === hoverIndex) {
            return;
        }
  
        const hoverBoundingRect = (findDOMNode(
            component,
        )).getBoundingClientRect();
  
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
  
        const clientOffset = monitor.getClientOffset();
  
        const hoverClientY = (clientOffset).y - hoverBoundingRect.top;
  
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
            return;
        }
  
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
            return;
        }
  
        props.moveCard(dragIndex, hoverIndex);
        monitor.getItem().index = hoverIndex;
    },

    drop(props, monitor, component) {
        if (monitor.didDrop()) {
            return
        }
        
        if (props.onSortSave!==undefined)
            props.onSortSave()
    }
}

class QuestionItem extends Component {

    constructor(props) {
        super(props)
        this.state = {isShowDrag:-1}
    }
        
    onMouseOver(index) {
        this.setState({isShowDrag:index})
    }

    onMouseOut() {
        this.setState({isShowDrag:-1})
    }

    onQuestionEditClick(item) {
        if (this.props.onQuestionEditClick!==undefined)
            this.props.onQuestionEditClick(item)
    }
    
    render() {
        const {connectDragSource,connectDropTarget,item,index,isDragging} = this.props
        const opacity = isDragging ? 0 : 1
        let {isShowDrag} = this.state
        let hover = (
            <OverlayTrigger
                key={'right'}
                placement={'right'}
                overlay={
                    <Tooltip id={'tooltip-right'}>
                        Hold & darg to sort the FAQs
                    </Tooltip>
                }
                >
                <div style={{display:isShowDrag===index?'':'none'}} className='card-tool'><Fontawesome name='ellipsis-v' /></div>
            </OverlayTrigger>
        )
        return (
            connectDragSource &&
            connectDropTarget &&
            connectDragSource(
                connectDropTarget(
                    <div onClick={this.onQuestionEditClick.bind(this,item)} onMouseOver={this.onMouseOver.bind(this,index)} onMouseOut={this.onMouseOut.bind(this)} style={{ ...style, opacity }} key={index} className='card card-question'>
                        {hover}
                        <div className='card-body'>
                            {item.title}
                            <div>
                                <span className={'label '+(item.is_hidden==='0'?'label-success':'label-default')}><small><Fontawesome name={item.is_hidden==='0'?'eye':'eye-slash'} /> {item.is_hidden==='0'?'Active':'Hidden'}</small></span>
                            </div>
                        </div>
                    </div>
                )
            )   
        )
    }
}

export default flow(
    DragSource(
        'question',
        cardSource,
        (connect, monitor) => ({
            connectDragSource: connect.dragSource(),
            isDragging: monitor.isDragging(),
        }),
    ),
    DropTarget('question', cardTarget, (connect) => ({
        connectDropTarget: connect.dropTarget(),
    }))    
)(QuestionItem);



// WEBPACK FOOTER //
// ./src/view/faq/QuestionItem.js